import { render, staticRenderFns } from "./ProjectDetailTab.vue?vue&type=template&id=a24b89ec&"
import script from "./ProjectDetailTab.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports